window.LayerPopup = Component.extend({
    layerData: undefined,
    currentPageId: undefined,

    $expert: undefined,
    $modalPopup: undefined,
    $closeButton: undefined,

    $modalBody: undefined,
    isOpen: undefined,
    expertXmlUrl: undefined,
    xmlLoader: undefined,
    previousFullscreenState: [],
    experts: [],
    $el: undefined,
    isExpertOpen: false,
    isCustomHelpContent: false,

    initialize: function(url) {
        this.url = url;
    },

    getDom: function() {
        return $(Handlebars.templates["components/layerpopup"]());
    },

    setup: function(container) {
        var self = this;

        this.layerData = [];
        this.container = container;
        this.session = this.container.getSession();

        let $content = $(this.getDom());

        this.$expert = $content.find(".layer-popup");
        this.$modalPopup = $content.find(".popup-window");
        this.$modalBackground = $content.find(".background");

        // Set the main stage DOM for other subclasses to access
        this.$el = $content;

        $content.addClass(this.name.toLowerCase());

        $(this.container.dom).append($content);

        this.$closeButton = this.$modalPopup.find(".close-button");
        this.$modalBody = this.$modalPopup.find(".modal-body");

        this.listenTo(this, "onExpertTrigger", this.handleOnExpertTrigger);

        this.listenTo(this.session, "onBeforeChangeSlide", this.handleOnBeforeChangeSlide);

        this.listenTo(this.session, "onChangeSlide", this.handleOnChangeSlide);

        this.listenTo(this.session, "onJunctionUpdate", this.handleOnJunctionUpdate);

        this.listenTo(this.container, "onResize", this.handleOnResize);

        this.listenTo(this.container, "onResizeComplete", this.handleOnResizeComplete);

        this.loadXML(this.url, "");
    },

    handleOnExpertTrigger: function(e) {
        this.checkForContent('Page.onExpertTrigger', e.target);
    },

    handleOnBeforeChangeSlide: function(e) {
        this.clearTimer();
    },

    handleOnChangeSlide: function(e) {
        // Swap page listeners to current page
        this.removePageListeners(e.previousPageData);
        this.addPageListeners(e.pageData);

        if (this.isPageComplete(e.pageData)) return;
        this.checkForContent('Page.onStarted', e.pageData);
    },

    handleOnJunctionUpdate: function(e) {
        var previousPageData = e.previousPageData;
        this.removePageListeners(previousPageData);

        var pageData = e.pageData;
        if (!pageData) return false;

        if (e.pageData.pageID() == 'home') {
            pageData = this.session.currentPageData;
        }

        if (this.isPageComplete(pageData)) return;

        this.checkForContent('Page.onStarted', pageData);
        this.addPageListeners(pageData);
    },

    isPageComplete: function(pageData) {
        if (pageData.getStatus() >= Status.COMPLETED) {
            return true;
        } else {
            return false;
        }
    },

    handleOnResize: function(e) {
        this.updatePosition();
    },

    handleOnResizeComplete: function(e) {
        this.updatePosition();
    },

    updatePosition: function() {
        var position = this.isOpen ? this.getShowPosition() : this.getHidePosition();

        TweenLite.set(
            this.$modalPopup, {
                top: position.top + "px",
                left: position.left + "px",
            }
        );
    },

    addPageListeners: function(pageData) {
        this.listenTo(pageData, 'onPassed', function(e) {
            this.checkForContent('Page.onPassed', e.target);
        });
        this.listenTo(pageData, 'onCompleted', function(e) {
            this.checkForContent('Page.onCompleted', e.target);
        });
        this.listenTo(pageData, 'onFailed', function(e) {
            this.checkForContent('Page.onFailed', e.target);
        });
    },

    removePageListeners: function(pageData) {
        this.stopListening(pageData, 'onPassed');
        this.stopListening(pageData, 'onCompleted');
        this.stopListening(pageData, 'onFailed');
    },

    loadXML: function(xmlPath, template) {
        var loader = new AssetLoader({
            name: this.name
        });

        loader.addXML(xmlPath, null, null, this, "handleXMLLoaded");
        loader.start();
    },

    handleXMLLoaded: function(e) {
        if (!e.loader.loaded) throw this.name + ": failed to load XML";

        var scope = this;
        var $xml = $(e.resource.getXML());
        $xml.find("items").find("item").each(function(i) {
            var selectionLabel = $(this).find("key").text();
            var selectionValue = $(this).find("value").text();
            var selectionEvent = $(this).find("event").text();
            var isMandatory = $(this).find("mandatory").text();

            scope.layerData.push({
                id: selectionLabel,
                eventName: selectionEvent,
                xml: selectionValue,
                isMandatory: isMandatory
            });
        });
    },

    customTrigger: function(pageData) {
        this.trigger("onExpertTrigger", {
            target: pageData
        });
    },


    checkForContent: function(eventName, pageData) {
        var contentMatch = false;
        for (var i = 0; i < this.layerData.length; i++) {
            var id = this.layerData[i].id;
            var expertEventTrigger = this.layerData[i].eventName;
            if (id == pageData.pageID() && eventName == expertEventTrigger) {
                this.isExpertOpen = true;
                contentMatch = true;

                this.clearPreviousContent();
                this.expertXmlUrl = this.layerData[i].xml;
                //Logger.info("onContentMatched", id, eventName);
                this.trigger("onContentMatched", {
                    pageID: id,
                    xmlUrl: this.layerData[i].xml,
                    eventName: eventName,
                    isMandatory: this.layerData[i].isMandatory
                });
            }
        }

        if (!contentMatch) {
            this.trigger("onNoContentMatched");

            this.hidePopupWindow();
        }
    },

    checkForCustomContent: function(pageID, customId) {
        var contentMatch = false;
        for (var i = 0; i < this.layerData.length; i++) {
            var id = this.layerData[i].id;
            var expertEventTrigger = this.layerData[i].eventName;
            var eventName = "Page.onExpertTrigger"; //this.layerData[i].eventName;

            if (id == customId && eventName == expertEventTrigger) {
                this.isExpertOpen = true;
                contentMatch = true;

                this.clearPreviousContent();
                this.expertXmlUrl = this.layerData[i].xml;
                this.trigger("onContentMatched", {
                    customId: customId,
                    pageID: pageID,
                    xmlUrl: this.layerData[i].xml,
                    eventName: eventName,
                    isMandatory: this.layerData[i].isMandatory
                });
            }
        }

        if (!contentMatch) {
            this.trigger("onNoContentMatched");

            this.hidePopupWindow();
        }
    },

    clearPreviousContent: function() {
        this.$modalBody.html("");
    },

    showExpert: function() {
        this.$expert.addClass("active");
    },

    startTimer: function() {
        var self = this;

        this.clearTimer();

        this.showExpertDeley = new Timer({
            timerInterval: 1
        });

        this.listenTo(this.showExpertDeley, "onTimerTick", function() {
            this.showExpertDeley.stopTicker();
            this.showExpert();
        });

        this.showExpertDeley.start();
    },

    clearTimer: function() {
        if (this.showExpertDeley) {
            this.showExpertDeley.stopTicker();
            this.showExpertDeley = null;
        }
    },


    hideExpert: function() {
        this.$expert.removeClass("active");
    },

    showPopupWindow: function() {
        this.isOpen = true;

        var self = this;

        this.$modalPopup.show();

        this.$expert.addClass("exit");

        if (this.previousFullscreenState < 1) {
            this.previousFullscreenState.push(this.container.isFullscreen);
        }

        var position = this.getShowPosition();

        TweenLite.to(
            this.$modalPopup,
            0.7, {
                top: position.top + "px",
                left: position.left + "px",
                onComplete: function() {
                    self.initCloseTriggers();
                }
            }
        );

        this.showBackground(true);

        this.trigger("onShow", {
            target: this
        });
    },

    initCloseTriggers: function() {
        var self = this;

        this.$modalBackground.bind(Pointer.getPress(true), function() {
            self.hidePopupWindow();
            self.$modalBackground.off();

            return false;
        });

        this.$closeButton.bind(Pointer.getPress(true), function() {
            self.hidePopupWindow();
            self.$closeButton.off();

            return false;
        });
    },

    hidePopupWindow: function() {
        this.isOpen = false;
        this.$expert.removeClass("exit");
        this.$modalPopup.removeClass("active");

        var self = this;
        var endPosition = (self.container.width * -1);

        var position = this.getHidePosition();

        TweenLite.to(
            this.$modalPopup,
            0.7, {
                top: position.top + "px",
                left: position.left + "px",
                onComplete: function() {
                    self.$modalPopup.hide();
                }
            }
        );

        this.showBackground(false);

        this.trigger("onHide", {
            target: this
        });
    },

    showBackground: function(isShowBackground) {
        var opacity = isShowBackground ? 1 : 0;
        var self = this;

        if (isShowBackground) {
            self.$modalBackground.parent().show();
        }

        // Hide the background
        TweenLite.set( // Do not use a transistion as this causes cleanup issues.
            this.$modalBackground, {
                opacity: opacity,
                onComplete: function() {
                    if (!isShowBackground) {
                        self.$modalBackground.parent().hide();
                        // self.hideMaskLayer();
                    }
                }
            }
        );
    },

    // TODO: This causes issues with help text popup on junction home screen,
    // makes it dissappear. Also this is pretty confusing as to whats happenning here,
    // do in another way for anim out.
    //

    getShowPosition: function() {
        var e = {
            top: 75,
            left: 0
        };

        return e;
    },

    getHidePosition: function() {
        var e = {
            top: 75,
            left: (this.container.width * -1)
        };

        return e;
    },

    getExperts: function() {
        return this.experts;
    },

    getExpertDataByName: function(name) {
        for (var i = 0; i < this.experts.length; i++) {
            if (name == this.experts[i].name) {
                return this.experts[i];
            }
        }
    }
});

// extending modal to decide on removing modal-open class by checking only one open currently, fix to avoid multiple scrollbars
(function($) {
    function trigger(target, name, relatedTarget) {
        target.trigger($.Event(name, {
            relatedTarget: relatedTarget
        }));
    }

    $.extend($.fn.modal.Constructor.prototype, {
        hideModal: function() {
            var that = this;
            this.$element.hide();
            this.backdrop(function() {
                if (that.$body.find(".modal").length <= 1) that.$body.removeClass('modal-open');
                that.resetAdjustments();
                that.resetScrollbar();
                that.$element.trigger('hidden.bs.modal');
            });
        }
    });
})(jQuery);
